import * as React from "react";
import Svg, { SvgProps, Path } from "react-native-svg";
const SvgComponent = (props: SvgProps) => (
  <Svg width={20} height={20} fill="none" {...props}>
    <Path
      fill="#000"
      d="M3.907 16.538c-.358 0-.66-.123-.908-.37a1.239 1.239 0 0 1-.37-.912v-8.14c0-.361.123-.665.37-.912s.551-.37.911-.37h3.667V4.742c0-.36.123-.665.37-.911.248-.247.55-.37.909-.37h2.288c.358 0 .661.123.908.37.247.248.371.551.371.911v1.09h3.667c.36 0 .664.124.91.371.248.247.372.551.372.911v8.141c0 .36-.124.664-.371.912-.247.247-.55.37-.908.37H3.907Zm.003-.769h12.18a.49.49 0 0 0 .352-.16.49.49 0 0 0 .16-.353v-8.14a.49.49 0 0 0-.16-.353.49.49 0 0 0-.352-.16H3.91a.49.49 0 0 0-.352.16.49.49 0 0 0-.16.352v8.141a.49.49 0 0 0 .16.353.49.49 0 0 0 .352.16Zm4.436-9.936h3.308v-1.09a.49.49 0 0 0-.16-.352.49.49 0 0 0-.353-.16H8.859a.49.49 0 0 0-.353.16.49.49 0 0 0-.16.352v1.09Z"
    />
  </Svg>
);
export default SvgComponent;
